/**
 * Utility functions for email customization
 */

/**
 * Removes any properties with empty string values from an object.
 *
 * IMPORTANT: This should only be used when preparing data to send to the API,
 * not for maintaining form state. Form state should preserve empty strings
 * to allow users to clear fields.
 *
 * @param obj The object to clean
 * @returns A new object with empty string fields removed
 */
export function removeEmptyStringFields<T extends object>(obj: T): T {
  const result = { ...obj };

  Object.entries(result).forEach(([key, value]) => {
    if (value === "") {
      delete result[key as keyof T];
    }
  });

  return result;
}
